<template>
    <div>
        <Modal v-model="openSpecMdl" width="640" class-name="vertical-center-modal no-padding">
            <div slot="header" class="title">产品规格选择</div>
            <div class="close-btn" slot="close">
                <i class="iconfont icon-pop-close"></i>
            </div>
            <div class="content">
                <div class="item" v-if="product.specs" :key="index" v-for="(item,index) in product.specs">
                    <div class="img">
                        <img :src="imgBaseUrl+item.specFile.key" v-if="item.specFile">
                        <img :src="imgBaseUrl+product.coverFile.key" v-else>
                        <div class="no-specail" v-if="item.visible !== 1">已下架</div>
                    </div>
                    <div class="info">
                        <p>{{item.color}}</p>
                        <p>{{item.size}}</p>
                        <p>{{item.material}}</p>
                    </div>
                    <div class="check-box" v-if="item.visible === 1 || selectedId == item.id">
                        <i class="icon" :class="{'active':selectedId == item.id}" @click="selectedId=item.id"></i>
                    </div>
                </div>
            </div>
            <div class="footer">
                <button  @click="submit">确 认</button>
            </div>
        </Modal>
    </div>
</template>
<style scoped>
    .content{
        padding:0 20px;
        max-height: 400px;
        overflow: auto;
    }
    .item{
        border-bottom: 2px solid #F2F4F5;
        overflow: hidden;
        text-align:left;
    }
    .item>div{
        display:inline-block;
        vertical-align: middle;
    }
    .item .img{
        width:104px;
        height:104px;
        line-height: 104px;
        padding:0 10px;
        position: relative;
    }
    .item .img .no-specail{
        position: absolute;
        width: 100%;
        height: 100%;
        line-height: 104px;
        text-align: center;
        background: rgba(108,111,112,0.80);
        color: #ffffff;
        font-size: 12px;
        top:4px;
        left: 4px;
    }
    .item .img img{
        vertical-align: middle;
    }
    .item .info{
        width:410px;
        margin-left:10px;
        padding-bottom: 0px;
    }
    .item .info p{
        font-size: 12px;
        color: #555555;
        line-height: 20px;
        text-align:left;
    }
    .item .check-box{
        width:50px;
        margin-left:-4px;
    }
    .item .check-box i{
        vertical-align: middle;
        display:block;
        width:20px;
        height:20px;
        margin:0 auto;
        border: 2px solid #A2A2A8;
        border-radius:50%;
    }
    .item .check-box i.active{
        background: rgb(245, 166, 35);;
        border: 2px solid rgb(245, 166, 35);;
    }
    .footer{
        padding:30px 0;
        text-align: center;
    }
    .footer button{
        width:145px;
        background: rgb(245, 166, 35);
        color:#fff;
    }
</style>
<script>
    import { imgBaseUrl} from '../../api/common'

    export default{
        data(){
            return {
                openSpecMdl:false,
                imgBaseUrl:imgBaseUrl,
                selectedId:0,
                product:{
                    specs:[]
                }
            }
        },
        methods:{
            submit(){
                this.openSpecMdl = false;
                this.$emit('submit',this.selectedId,this.product.id);
            },
            open(product,selectedSpecId){
                this.product = product;
                this.selectedId = selectedSpecId||this.product.specs[0].id;
                this.openSpecMdl = true;
            }
        },
    }

</script>